import { Component } from 'react';

import MobileSectionButtons from './mobile-section-buttons';
import MobileSectionHandler from './mobile-section-handler';

export default class SeventyThirtyLayout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedSection: null,
        }
    }

    onSectionClick(section) {
        this.setState({ selectedSection: section });
    }

    onSectionClose() {
        this.setState({ selectedSection: null });
    }

    render() {
        const { main, sectionOne, sectionTwo } = this.props;
        const sections = [];

        if (sectionOne) sections.push(sectionOne);
        if (sectionTwo) sections.push(sectionTwo);

        return (
            <div class="layout__inner layout__seventy-thirty">
                <div className="layout__main-container">{ main }</div>

                <MobileSectionHandler sections={sections} selectedSection={this.state.selectedSection} onSectionClose={this.onSectionClose.bind(this)}>
                    { sectionOne ? sectionOne.component : '' }
                    { sectionTwo ? sectionTwo.component : '' }
                </MobileSectionHandler>
            </div>
        )
    }
}
